export const TYPE_LABELS: Record<string, string> = {
  festival: "Festival",
  vrat: "Vrat",
  eclipse: "Eclipse",
  tithi_based: "Tithi-based",
};

// Hindi twin of TYPE_LABELS — the type badge on /hi/calendar/festival/<id>/.
export const TYPE_LABELS_HI: Record<string, string> = {
  festival: "पर्व",
  vrat: "व्रत",
  eclipse: "ग्रहण",
  tithi_based: "तिथि-आधारित",
};

export const TYPE_COLORS: Record<string, { bg: string; border: string; text: string }> = {
  festival: {
    bg: "rgba(234, 88, 12, 0.08)",
    border: "rgba(234, 88, 12, 0.3)",
    text: "var(--color-warning-orange-dark)",
  },
  vrat: {
    bg: "rgba(22, 163, 74, 0.08)",
    border: "rgba(22, 163, 74, 0.25)",
    text: "var(--color-success-text)",
  },
  eclipse: {
    bg: "rgba(107, 33, 168, 0.08)",
    border: "rgba(107, 33, 168, 0.25)",
    text: "#7e22ce",
  },
  tithi_based: {
    bg: "rgba(37, 99, 235, 0.08)",
    border: "rgba(37, 99, 235, 0.25)",
    text: "#1d4ed8",
  },
};

export function formatDate(dateStr: string): string {
  if (!dateStr) return "—";
  const d = new Date(dateStr + "T00:00:00");
  return d.toLocaleDateString("en-IN", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
